<template>
    <flex-element
        :element-type="elementType"
        class="f-break-words"
        tag="label"
        :for="labelFor"
    >
        {{ formattedValue }}
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import FlexElement from '@/flex-element/flex-element-dumb';

export default {
    name: 'a-label',
    components: { FlexElement },
    mixins: [baseAtom],

    props: {
        singleLineText: {
            type: String,
            default: '',
        },

        labelFor: {
            type: String,
            default: '',
        },
    },

    computed: {
        formattedValue() {
            return this.singleLineText;
        },
    },
};
</script>
